import React from 'react';
import './PresidentMessage.css';
import pic1 from "../assets/jaideepbihani.webp";

const PresidentMessage = () => {
  const councilMembers = [
    { name: 'Sh. Jaideep Bihani', role: '(President)' },
    { name: 'Sh. Himanshu Bihani', role: '(Vice President)' },
    { name: 'Mrs. Nalini Dhingra', role: '(Principal & Secretary)' },
    { name: 'Sh. Deepak Jain S/o Sh. Manmohan Jain', role: ' (Member/Trustee)' },
    { name: 'Sh. Madhu Sudan Bihani S/o Sh. Suhil Kumar Bihani', role: ' (Member/Trustee)' },
    { name: 'Sh. Sharad Kumar Bihani', role: '(Member/Trustee)' },
    { name: 'Sh. Vimal Bihani', role: '(Member)' },
    { name: 'Sh. Satish Chander Jain', role: '(Member)' },
    { name: 'Smt. Ranjana Bihani', role: '(Member)' },
    { name: 'Smt. Shailja Chitlangyia W/o Sh. Rakesh Chitlangyia', role: ' (Member)' },
    { name: 'Smt. Shruti Bihani W/o Sh. Neeraj Bihani', role: ' (Member)' },
    { name: 'Smt. Monika Bihani', role: '(Member)' },
    { name: 'Smt. Urmila Chitlangyia D/o Sh. Shankar Lal Bhattar', role: ' (Member)' },
    { name: 'Smt. Kavita Binnani W/o Sh. Prashant Binnani', role: ' (Member)' },
    { name: 'Dr. Richa Periwal W/o Dr. Aditya Periwal', role: ' (Member)' },
    { name: 'Sh. M.S. Vig - Principal CBSE School', role: ' (Member)' },
    { name: 'Smt. Minu Sharma - Principal CBSE School', role: ' (Member)' },
    { name: 'Smt. Nalini Dhingra - Academy Teacher', role: ' (Member)' },
    { name: 'Sh. Varun Maheshwari Member', role: ' (Lecturer Other Dept)' },
    { name: 'Dr. Gulshan Kumar', role: '(College Lecturer)' },
    { name: 'Dr. Ajay Sharma', role: '- Present Students Parents' },
    { name: 'Present Students Parents', role: '' },
  ];

  return (
    <>
    {/* Banner Section with Background Image */}
      <section className="inner-bannerlib">
        <div className="banner-container">
          <h1>MESSAGE FROM PRESIDENT</h1>
        </div>
      </section>

      {/* Breadcrumb */}
      <section className="breadcrumb-section">
        <div className="breadcrumb-container">
          <ul className="breadcrumb-list">
            <li><a href="/">Home</a></li>
            <li>/</li>
            <li>President</li>
          </ul>
        </div>
      </section>
    <div className="page-container">
      <div className="main-container">
        <div className="header">
          <h1 className="header-title">President's Message</h1>
        </div>

        <div className="content">
          <div className="left-section">
            <div className="president-card">
              <div className="president-img">
                <img src={pic1} alt="President Jaideep Bihani" />
              </div>
              <p className="president-label">PRESIDENT</p>
              <h2 className="president-name">SHRI JAIDEEP BIHANI</h2>
              <p className="president-title">President Seth G.L. Bihani S.D. Shiksha Trust & Bihani Children's Academy</p>
            </div>

            <div className="quote-box">
              "Education is not the learning of facts But the training of mind to think"
            </div>

            <div className="mission-box">
              <p>
                Learning all over the world has undergone a radical change. Knowledge is no longer constrained by time and space but has expanded beyond classrooms. Technology and innovative techniques are the key facilitators of success in the time of Digital Revolution. Our pedagogical practices have to shift from traditional approach to E-learning in emerging global scenario. Bihani Children's Academy right from its inception in 1989 aims to groom students to ethical leaders embedded with values. Our priority is to provide intellectual stimulation to the young minds with wealth of learning opportunities. I believe that Education should enable the students to soar so high morally, socially and spiritually with milestones of knowledge, introspection and humility that one becomes productive and responsible citizens of the country.
              </p>
            </div>
          </div>

          {/* Management Council Sidebar */}
        <div className="bca-council-box">
          <h2 className="bca-council-title">Management Council</h2>
          <ul className="bca-council-members">
            {councilMembers.map((member, index) => (
              <li key={index} className="bca-council-member">
                <strong>{member.name}</strong> {member.role && <span>{member.role}</span>}
              </li>
            ))}
          </ul>
        </div>
        </div>
      </div>
    </div>
              </>
  );
};

export default PresidentMessage;